import {
  Combobox,
  ComboboxButton,
  ComboboxInput,
  ComboboxOption,
  ComboboxOptions
} from '@headlessui/react'
import { ChevronUpDownIcon } from '@heroicons/react/16/solid'
import { AnimatePresence, motion } from 'framer-motion'
import { useState } from 'react'

import { isSampleCareer } from '../../../../helpers/sample-data'
import CareerComboboxOption from './CareerComboboxOption'

export default function CareerSearchCombobox({
  careers,
  selectedCareers,
  onCareerAdd,
  placeholder
}) {
  const [query, setQuery] = useState('')

  const filteredCareers =
    query === ''
      ? careers.filter(
          (c) => !selectedCareers.some((selected) => selected.id === c.id)
        )
      : careers.filter(
          (c) =>
            (c.title.toLowerCase().includes(query.toLowerCase()) ||
              c.id.toString().toLowerCase().includes(query.toLowerCase())) &&
            !selectedCareers.some((selected) => selected.id === c.id)
        )

  const handleCareerSelect = (career) => {
    onCareerAdd(career)
    setQuery('')
  }

  console.log('careers', careers)
  return (
    <Combobox
      value={selectedCareers}
      onChange={() => {}}
      multiple
      immediate
      onClose={() => setQuery('')}
    >
      {({ open }) => (
        <div className='relative'>
          <ComboboxInput
            className='w-full rounded-md border border-gray-300 bg-white px-3 py-3 text-base placeholder-gray-500 focus:border-primaryBlue focus:outline-none focus:ring-1 focus:ring-primaryBlue'
            placeholder={placeholder}
            onChange={(event) => setQuery(event.target.value)}
            displayValue={() => query}
          />
          <ComboboxButton className='absolute inset-y-0 right-0 flex items-center pr-3'>
            <ChevronUpDownIcon className='size-5 text-mediumGrey' />
          </ComboboxButton>
          <AnimatePresence>
            {open && (
              <ComboboxOptions
                as={motion.div}
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.95 }}
                static
                className='absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-lg border border-gray-200 bg-white shadow-lg'
                onAnimationComplete={() => setQuery('')}
              >
                {filteredCareers.length === 0 && query !== '' ? (
                  <div className='px-4 py-3 text-sm text-gray-500'>
                    Keine Stellen gefunden
                  </div>
                ) : (
                  filteredCareers.map((career) => (
                    <ComboboxOption
                      key={career.id}
                      value={career}
                      className='cursor-pointer select-none'
                    >
                      {({ focus }) => (
                        <CareerComboboxOption
                          career={career}
                          onAdd={handleCareerSelect}
                          focus={focus}
                          isDemo={isSampleCareer(career)}
                        />
                      )}
                    </ComboboxOption>
                  ))
                )}
              </ComboboxOptions>
            )}
          </AnimatePresence>
        </div>
      )}
    </Combobox>
  )
}
